module.exports = __webpack_public_path__ + "media/images/og-9f658691f4dda43ad23fbd7ea5047125.jpg";